import APIClient from '@/shared/http/clients/api'

const resourceName = 'login-fila'
const APIAccess = process.env.APIBaseBPM

const SignInFila = (data = {}, config = {}) => APIClient.post(`${APIAccess}/${resourceName}`, data, config)
const SignOutFila = (data = {}, config = {}) => APIClient.post(`${resourceName}/signOut`, data, config)

const AuthFilaRepository = {
  SignInFila,
  SignOutFila
}

export default AuthFilaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/authFila.js